export const customers = {
  title: 'Khách hàng',
  resourceName: 'Khách hàng',
  titles: {
    detail: 'Chi tiết khách hàng',
    view: 'Chi tiết khách hàng',
    show: 'Xem khách hàng',
    edit: 'Chỉnh sửa khách hàng',
    create: 'Tạo khách hàng',
    list: 'Danh sách khách hàng',
    addQuick: 'Thêm nhanh',
  },
  messages: {
    noData: 'Không có dữ liệu',
    totalCustomers: 'Tổng: {total} khách hàng',
    savedSuccess: 'Đã lưu thành công',
    saving: 'Đang lưu...',
    updateSuccess: 'Cập nhật khách hàng thành công',
    createSuccess: 'Tạo khách hàng thành công',
    errorGeneric: 'Có lỗi xảy ra',
    loadDetailError: 'Không tải được chi tiết khách hàng',
  },
  validation: {
    codeNameRequired: 'Vui lòng nhập mã và tên khách hàng',
    codeRequired: 'Vui lòng nhập mã khách hàng',
    nameRequired: 'Vui lòng nhập tên khách hàng',
    emailInvalid: 'Email không hợp lệ',
  },
  status: {
    active: 'Hoạt động',
    inactive: 'Không hoạt động',
    pending: 'Đang chờ',
  },
  gender: {
    male: 'Nam',
    female: 'Nữ',
    other: 'Khác',
  },
  fields: {
    companyName: 'Công ty',
    phoneNumber: 'Số điện thoại',
    id: 'ID',
    name: 'Tên',
    email: 'Email',
    phone: 'Số điện thoại',
    address: 'Địa chỉ',
    area: 'Khu vực',
    status: 'Trạng thái',
    isActive: 'Trạng thái',
    createdAt: 'Ngày tạo',
    actions: 'Hành động',
    fromWarehouse: 'Từ kho',
    toWarehouse: 'Đến kho',
    toWarehouseCode: 'Mã kho đích',
    container: 'Container',
    totalVolume: 'Tổng thể tích',
    totalWeight: 'Tổng trọng lượng',
    subCode: 'Mã phụ',
    salesName: 'Sales',
    pricePerKg: 'Giá theo kg',
    pricePerM3: 'Giá theo m3',
    priceEachRow: 'Giá theo dòng',
    entrustmentPercent: 'UTNK / Lấy thuế',
    code: 'Mã',
    getTax: 'Lấy thuế',
    codeLabel: 'Mã khách hàng',
    nameLabel: 'Tên khách hàng',
    updatedAt: 'Ngày cập nhật',
    notes: 'Ghi chú',
  },
  tabs: {
    mapping: 'Mã phụ',
  },
  searchByCode: {
    label: 'Chỉ hiển thị bản ghi thiếu mã chính',
    placeholder: 'Tìm theo mã, tên khách hàng',
  },
  filter: {
    placeholder: 'Tìm kiếm khách hàng',
    advancedFilter: 'Lọc nâng cao',
    code: 'Mã khách hàng',
    name: 'Tên khách hàng',
    sales: 'Sales',
    allSales: 'Tất cả Sales',
    clearFilter: 'Xóa lọc',
    search: 'Tìm kiếm',
  },
  customerNotFound: 'Khách hàng không tồn tại',
  attachMainCode: 'Gắn mã chính',
  import: {
    button: 'Import',
    title: 'Import khách hàng',
    description: 'Chọn file XLSX (định dạng theo file mẫu).',
    noSheet: 'Không tìm thấy sheet trong file Excel',
    readError: 'Đọc file Excel thất bại',
    noData: 'Chưa có dữ liệu để import',
    success: 'Import thành công {count} khách hàng',
    failed: 'Import thất bại',
    savedSuccess: 'Đã lưu thành công',
    templateSheetName: 'Mẫu nhập khách hàng',
    templateFileName: 'Mau_nhap_khach_hang.xlsx',
    templateSuccess: 'Tải file mẫu thành công',
    templateFailed: 'Tải file mẫu thất bại',
    templateLoading: 'Đang tải...',
    templateButton: 'Tải file mẫu',
  },
  export: {
    button: 'Export',
    loading: 'Đang xuất...',
    success: 'Xuất file Excel thành công',
    failed: 'Xuất file thất bại',
    fileName: 'Danh_sach_khach_hang.xlsx',
    fileNameMapping: 'Danh_sach_ma_phu.xlsx',
    sheetName: 'Danh sách khách hàng',
    mappingSheetName: 'Danh sách mã phụ',
  },
  mapping: {
    editTitle: 'Sửa mã phụ',
    importSuccess: 'Import mã phụ thành công',
    importLoading: 'Đang import...',
    importTitle: 'Import mã phụ',
    importDescription: 'Chọn file XLSX (định dạng theo file mẫu).',
    templateSheetName: 'Mẫu nhập mã phụ',
    templateFileName: 'Mau_nhap_ma_phu.xlsx',
    templateSubCode: 'Mã sub',
    templateCustomerCode: 'Mã khách hàng',
    templateWarehouseCode: 'Mã kho',
    templatePriceEachRow: 'Giá/kiện',
    templatePricePerKg: 'Giá/kg',
    templatePricePerM3: 'Giá/m³',
    templateIsGetTax: 'Khách lấy thuế',
    templateEntrustmentPercent: '% ủy thác',
  },
  form: {
    basicInfo: 'Thông tin cơ bản',
    contactInfo: 'Thông tin liên hệ',
    managerInfo: 'Thông tin người quản lý',
    servicePriceInfo: 'Thông tin dịch vụ & giá',
    otherInfo: 'Thông tin khác',
    isActiveLabel: 'Đang hoạt động',
    noSelect: 'Không chọn',
    getTaxLabel: 'Lấy hóa đơn',
    createdByPlaceholder: 'Người tạo',
    introduceByPlaceholder: 'Người giới thiệu',
    inChargeByPlaceholder: 'Người phụ trách',
    areaPlaceholder: 'Khu vực',
    entrustmentPlaceholder: 'Phần trăm ủy thác',
    priceEachRowPlaceholder: 'Giá mỗi dòng',
    pricePerKgPlaceholder: 'Giá mỗi kg',
    pricePerM3Placeholder: 'Giá mỗi m³',
    genderLabel: 'Giới tính',
  },
}
